import { FormattedMessage } from 'react-intl';
import Section from './Section';
import { useState } from 'react';
import List from '@/components/List/List';
import { useQuery } from '@tanstack/react-query';
import SearchTextField from '@/components/SearchTextField/SearchTextField';
import { fetchFilters } from '@/lib/api';
import FilterOptionsUnavailable from './FilterOptionsUnavailable';

const GameFamily = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const [search, setSearch] = useState('');
  const { isPending, isError, data } = useQuery({
    queryKey: ['filters'],
    queryFn: fetchFilters,
  });
  const filteredItems = (
    data?.game_families.filter((item) =>
      item.toLowerCase().includes(search.toLowerCase()),
    ) || []
  ).map((item) => ({
    id: item,
    label: item,
    value: item,
  }));

  return (
    <Section
      title={
        <FormattedMessage
          id="gameFamily"
          defaultMessage="Game Family"
        />
      }
      mode={mode}
      defaultOpen={value.length > 0}
    >
      {isError && !data ? (
        <FilterOptionsUnavailable />
      ) : (
        <>
          <SearchTextField
            value={search}
            onChange={(newV) => setSearch(newV)}
            mode={mode}
          />
          <List
            loading={isPending}
            items={filteredItems}
            values={value}
            onChange={(values) => onChange(values as string[])}
            mode={mode}
          />
        </>
      )}
    </Section>
  );
};

export default GameFamily;
